import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/image/importer/imageImporterSelectors';
import ImageService from 'src/modules/image/imageService';
import fields from 'src/modules/image/importer/imageImporterFields';
import { i18n } from 'src/i18n';

const imageImporterActions = importerActions(
  'IMAGE_IMPORTER',
  selectors,
  ImageService.import,
  fields,
  i18n('entities.image.importer.fileName'),
);

export default imageImporterActions;